import { render, staticRenderFns } from "./CustomWebhook.vue?vue&type=template&id=89f20120"
import script from "./CustomWebhook.vue?vue&type=script&lang=js"
export * from "./CustomWebhook.vue?vue&type=script&lang=js"
import style0 from "./CustomWebhook.vue?vue&type=style&index=0&id=89f20120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports